import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs'

export default class extends Controller {
  connect() {
    this.loadChannelPositions()
    this.makeSortable()
  }

  loadChannelPositions() {
    const positions = this.getChannelPositions()

    // Appliquer les positions personnalisées
    const container = this.element.querySelector('.sortable-channels')
    const channels = Array.from(container.children)

    // Trier selon les positions personnalisées
    channels.sort((a, b) => {
      const channelA = a.querySelector('input[type="checkbox"]')?.value
      const channelB = b.querySelector('input[type="checkbox"]')?.value

      const posA = positions[channelA] || 999
      const posB = positions[channelB] || 999

      return posA - posB
    })

    // Réorganiser le DOM
    channels.forEach(channel => {
      container.appendChild(channel)
    })
  }

  makeSortable() {
    const container = this.element.querySelector('.sortable-channels')
    new Sortable(container, {
      animation: 150,
      ghostClass: 'opacity-50',
      chosenClass: 'bg-violet-100',
      dragClass: 'shadow-lg',
      handle: '.drag-handle',

      onEnd: (evt) => {
        this.saveNewPositions()
      }
    })
  }

  saveNewPositions() {
    const positions = {}
    const container = this.element.querySelector('.sortable-channels')

    container.querySelectorAll('input[type="checkbox"]').forEach((checkbox, index) => {
      const channelId = checkbox.value
      positions[channelId] = index + 1
    })

    localStorage.setItem('tv_channel_positions', JSON.stringify(positions))

    // Mettre à jour les affichages de position
    container.querySelectorAll('[data-position-display]').forEach((element, index) => {
      element.textContent = `Position ${index + 1}`
    })

    // Émettre un événement pour notifier que les positions ont changé
    window.dispatchEvent(new CustomEvent('channelPositionsChanged', { detail: positions }))

      }

  getChannelPositions() {
    try {
      const stored = localStorage.getItem('tv_channel_positions')
      return stored ? JSON.parse(stored) : {}
    } catch (e) {
            return {}
    }
  }
}